import React from "react";
import { observer, inject } from "mobx-react";
import { Banner, BannerFrame } from "ComponentsUI/Banner";
import OuthomeBenefitsContainer from "Containers/OuthomeBenefitsContainer";
import images from "Configs/images.config";
import { replaceStaticHost } from "Helpers/ImageManager";
import FormContainer from "../routes/orders/routes/outhome/Containers/FormContainer";

@inject("ApplicationModel")
@observer
export default class OuthomeBannerContainer extends React.Component {
	render() {
		let applicationModel = this.props.ApplicationModel;
		let textConfig = applicationModel.text;
		let region = this.props.ApplicationModel.currentRegion;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		let imageHeroBannerSlide1 =
			!!region && !!region.image_lg
				? {
						lg: replaceStaticHost(region.image_lg),
						md: replaceStaticHost(region.image_md),
						sm: replaceStaticHost(region.image_sm),
						xs: replaceStaticHost(region.image_xs),
					}
				: {
						lg: replaceStaticHost(images.heroBannerLg),
						md: replaceStaticHost(images.heroBannerMd),
						sm: replaceStaticHost(images.heroBannerSm),
						xs: replaceStaticHost(images.heroBannerXs),
					};

		let middleComponent = <FormContainer autoFocus={true} windowSizes={windowSizes} />;

		let subheaderForFrame = this.props.h1After;

		let content = (
			<BannerFrame
				title={this.props.h1Banner}
				center={true}
				subheader={subheaderForFrame}
				heroVideoButton={textConfig.heroVideoButton}
				bottomComponent={middleComponent}
			/>
		);

		let BottomComponent = <OuthomeBenefitsContainer text={textConfig} />;

		return (
			<Banner
				heroInternet={textConfig.heroInternet}
				background={imageHeroBannerSlide1}
				content={content}
				windowSizes={windowSizes}
				bottomComponent={BottomComponent}
			/>
		);
	}
}
